export default function canDeleteScenes(scribe, sceneIdsToDelete) {
  return !(scribe.scenes.length - sceneIdsToDelete.length <= 0);
}
